import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { newProductCreation,resetProductCreatiion,imageuploadProcess,imageUploadFailureProcess } from "./productAction";
import { newPaxhealthCreation,resetPaxhealthCreatiion } from "../paxhealth/paxhealthAction";
import { newProductAgePolicyCreation } from "../agepolicy/agepolicyAction";
import { newProductOccupancyRuleCreation } from "../occupancyrule/occupancyruleAction";
import { newProductCancelPolicyCreation } from "../cancelpolicy/cancelpolicyAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { getAllServiceType } from "../serviceType/serviceTypeAction";
import { getAllReservationEmail } from "../reservationemails/ReservationEmailAction";
import { getAllSupplier } from "../suppliers/supplierAction";
import { getAllCity } from "../city/cityAction";
import { getAllTourType } from "../tourTypes/TourTypeAction";
import { getAllCountry } from "../country/countryListAction";
import Datetime from "react-datetime";
import { DefaultEditor } from 'react-simple-wysiwyg';
import { upload } from '@testing-library/user-event/dist/upload';
import UploadService from "../../../api/FileUploadApi";
import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2'
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css'
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { FaEdit, FaTrash, FaPlus, FaEye, FaArrowLeft } from 'react-icons/fa';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MuiAlert from '@mui/material/Alert';



const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CreateProduct = () => {
  const dispatch = useDispatch();
  const ProductRef = useRef(null);
  const navigate = useNavigate();
  const [productname,setProductname]= useState('');
  const [amiweight,setAmiWeight]= useState('');
  const [amaweight,setAmaWeight]= useState('');
  const [amiheight,setAmiHeight]= useState('');
  const [adultage,setAdultAge]= useState('');
  const [minadult,setMinAdult]= useState('');
  const [maxadult,setMaxAdult]= useState('');
  const [snackopen, setSnackOpen] = useState(false);
  const [snackopen2, setSnackOpen2] = useState(false);
  const [snackopen3, setSnackOpen3] = useState(false);
  const [snackopen4, setSnackOpen4] = useState(false);
  const [snackopen5, setSnackOpen5] = useState(false);

  const [minchild,setMinChild]= useState('');
  const [maxchild,setMaxChild]= useState('');
  const [dup, setDup] = useState(true);

  
  const [mininfant,setMinInfant]= useState('');
  const [maxinfant,setMaxInfant]= useState('');

  const [schildage,setSChildAge]= useState('');
  const [echildage,setEChildAge]= useState('');
  const [paxchildshow,setPaxChildShow] = useState(true);
  const [paxinfantshow,setPaxInfantShow] = useState(true);
  const [paxadultshow,setPaxAdultShow] = useState(true);

  const [sinfantage,setSInfantAge]= useState('');
  const [einfantage,setEInfantAge]= useState('');
  const [amaheight,setAmaHeight]= useState('');

  const [cmiweight,setCmiWeight]= useState('');
  const [cmaweight,setCmaWeight]= useState('');
  const [cmiheight,setCmiHeight]= useState('');
  const [cmaheight,setCmaHeight]= useState('');


  const [sdate,setSdate]= useState('');
  const [edate,setEdate]= useState('');
  const [cbdays,setCbdays]= useState('');
  const [cbhours,setCbhours]= useState('');
  const [percentage,setPercentage]= useState('');
  const [bdays,setBdays]= useState('');
  const [minamt,setMinamt]= useState('');
  const [cremarks,setCRemarks]= useState('');



  const [servicetypeid,setServicetypeid]= useState('');
  const [tourtypeid,setTourtypeid]= useState('');
  const [phonenumber,setPhonenumber]= useState();
  const [cityid,setCityid]= useState('');
  const [countryid,setCountryid]= useState('');
  const [reservationmailid,setReservationmailid]= useState([]);
  const [locationid,setLocationid]= useState('');
  const [ageview,setAgeView] = useState(false);
  const [cancelpview,setCancelpView] = useState(false);
  const [dailystarttime,setDailystarttime]= useState('');
  const [dailyendtime,setDailyendtime]= useState('');
  const [nooftrips,setNooftrips]= useState('');
  const [dresscode,setDresscode]= useState('');
  const [remarks,setRemarks]= useState('');
  const [itenarygroupid,setItenarygroupid]= useState('');
  const [supplierid,setSupplierid]= useState([]);
  const [isdummy,setIsdummy]= useState('');
  const [acp,setIsacp]= useState('');
  const [aip,setIsaip]= useState('');
  const [aap,setIsaap]= useState('');
  const [istricombo,setIstricombo]= useState('');
  const [isbulkticket,setIsbulkticket]= useState('');
  const [hasvat,setHasvat]= useState('');
  const [vouchertosbt,setVouchertosbt]= useState('');
  const [hastax,sethastax]= useState('');
  const [productdescription,setProductdescription]= useState('');
  const [healthrestrictions,setHealthrestrictions]= useState('');
  const [status,setStatus]= useState('');
  const [status2,setStatus2]= useState('');

  //Image Upload
  const [files,setFiles]= useState([]);
  const [dayShow,setDayShow] = useState(false);
  const [timeShow,setTimeShow] = useState(false);

  const [perShow,setPerShow] = useState(false);
  const [minamtShow,setMinamtShow] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [progressInfos, setProgressInfos] = useState([]);
  const [message, setMessage] = useState([]);
  const [imageInfos, setImageInfos] = useState([]);
  const progressInfosRef = useRef(null);


  const handleChangeSupplier = (evt, options) => {
    evt.persist();
    const lastAddedItem = options[options.length -1];
    if (evt.target.checked) {setSupplierid([...supplierid,  lastAddedItem?.id]);} 
    else { removeSupplier(lastAddedItem?.id) } 
}
  
  const removeSupplier = (id) => { setSupplierid([...supplierid.filter((supplierid) =>
    supplierid == id)]) }


    const handleChangeREmail = (evt, options) => {
      evt.persist();
      const lastAddedItem = options[options.length -1];
      if (evt.target.checked) {setReservationmailid([...reservationmailid,  lastAddedItem?.id]);} 
      else { removeREmail(lastAddedItem?.id) } 
  }
    
    const removeREmail = (id) => { setReservationmailid([...reservationmailid.filter((supplierid) =>
      supplierid == id)]) }
  

  const fileref = useRef('');
   //Image Upload
  
  const [alertStatus, setAlertStatus] = useState('');
  const [tabHandle, setTabHandle] = useState('basic');
  const { register, reset, handleSubmit, formState: { errors } } = useForm();
  const [ageButton , setAgeButton ] = useState(true);
  const [cancelButton , setCancelButton ] = useState(true);
 
  const { piscLoading, pcstatus, pcMessage,productId } = useSelector((state) => state.productList);
  const { prdata,paxMessage,paxstatus } = useSelector((state) => state.paxList);
  const { serviceType } = useSelector((state) => state.serviceTypiesList);
  const { tourType } = useSelector((state) => state.tourTypesList);
  const { reservationEmail } = useSelector((state) => state.reservationEmailsList);
  const { city } = useSelector((state) => state.citiesList);
  const { country } = useSelector((state) => state.countryList);
  const { suppliers } = useSelector((state) => state.supplierList);
  const handleCheckbox = (e) => {
    const checked = e.target.checked;
    if (e.target.name == "isdummy" && checked) {
      setIsdummy(1);
    } 
    else if (e.target.name == "istricombo" && checked) {
      setIstricombo(1);
    } 

    else if (e.target.name == "isbulkticket" && checked) {
      setIsbulkticket(1);
    }
    else if (e.target.name == "hasvat" && checked) {
      setHasvat(1);
    } 
    else if (e.target.name == "hastax" && checked) {
      sethastax(1);
    } 
    
    else if (e.target.name == "vouchertosbt" && checked) {
      setVouchertosbt(1);
    } 

  };

  
  // const handleCheckbox2 = (e) => {
  //   const checked = e.target.checked;
  //   if (e.target.name == "acp" && checked) {
  //     setIsacp(1);
  //     setPaxChildShow(false)
  //   } else{
  //     setIsacp(0);
  //     setPaxChildShow(true)

  //   }
  //   if (e.target.name == "aip" && checked) {
  //     setIsaip(1);
  //     setPaxInfantShow(false)
  //   } else{
  //     setIsaip(0);
  //     setPaxInfantShow(true)

  //   }
  //   if (e.target.name == "aap" && checked) {
  //     setIsaap(1);
  //     setPaxAdultShow(false)
  //   } else{
  //     setIsaap(0);
  //     setPaxAdultShow(true)
  //   }

    
  // };


    
  const handleCheckboxAcp = (e) => {
    const checked = e.target.checked;
    if (e.target.name == "acp" && checked) {
      setIsacp(1);
      setPaxChildShow(false)
    } else {
      setIsacp(0);
      setPaxChildShow(true)

    }
  }
  const handleCheckboxAip = (e) => {
    const checked = e.target.checked;
    if (e.target.name == "aip" && checked) {
      setIsaip(1);
      setPaxInfantShow(false)
    } else {
      setIsaip(0);
      setPaxInfantShow(true)

    }
  }
  const handleCheckboxAap = (e) => {
    const checked = e.target.checked;
    if (e.target.name == "aap" && checked) {
      setIsaap(1);
      setPaxAdultShow(false)
    } else {
      setIsaap(0);
      setPaxAdultShow(true)
    }


  };

  const handleageview = (e) => {
    setAgeView(!ageview)

  };

  const handlecancelview = (e) => {
   setCancelpView(!cancelpview)
    
  };

  useEffect(() => {
    dispatch(getAllServiceType());
    dispatch(getAllReservationEmail());
    dispatch(getAllSupplier());
    dispatch(getAllCity());
    dispatch(getAllCountry());
    dispatch(getAllTourType());
    dispatch(resetProductCreatiion());
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();
   
    
    if(Boolean (productname) && Boolean (servicetypeid) && Boolean (tourtypeid) && Boolean (cityid) && Boolean (countryid)  && Boolean (reservationmailid) && Boolean (status)){
    
       setIsdummy(1);
      setLocationid(0);
      
        const newProductCreation1 = {
            productname,
            servicetypeid,
            tourtypeid,
            phonenumber,
            cityid,
            countryid,
            reservationmailid,
            locationid,
            // dailystarttime,
            // dailyendtime,
            nooftrips,
            // dresscode,
            remarks,
            supplierid,
            isdummy,
            // istricombo,
            isbulkticket,
            hasvat,
            // vouchertosbt,
            hastax,
            productdescription,
            status
	
          }

        dispatch(
            newProductCreation(newProductCreation1)
        )
        setSnackOpen5(true)
        
       
      
    }
   
     
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackOpen(false);
  };
  const action = (
    <React.Fragment>
   
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );




  const handleClose2 = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackOpen2(false);
  };
  const action2 = (
    <React.Fragment>
   
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose2}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const handleClose3 = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackOpen3(false);
  };
  const action3 = (
    <React.Fragment>
   
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose3}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );




  const handleClose4 = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackOpen4(false);
  };
  const action4 = (
    <React.Fragment>
   
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose4}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );




  const handleClose5 = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackOpen5(false);
  };
  const action5 = (
    <React.Fragment>
   
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose5}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const handleBefore = (e) =>{

  if(e == "Day"){
    setDayShow(true);
    setTimeShow(false)
  }else if(e == "Hour"){
    setTimeShow(true)
    setDayShow(false);
  }
  }


  const handlePercentage = (e) => {

    if (e == "Percentage") {
      setPerShow(true);
      setMinamtShow(false)
    } else if (e == "Minamt") {
      setMinamtShow(true)
      setPerShow(false);
    }
  }
  


  const handleOnSubmit2 = (e) => {
    e.preventDefault();
   
        const newProductCreation2 = {
            amiweight,
            amaweight,
            amiheight,
            amaheight,
            cmiweight,
            cmaweight,
            cmiheight,
            cmaheight,
            acp,
            aip,
            aap,
            healthrestrictions,
            status2,
            productId
          }
          setSnackOpen(true)

        dispatch(
          newPaxhealthCreation(newProductCreation2)
        )
       
      
       
     
  }




  
  const handleOnSubmit3 = (e) => {
    e.preventDefault();
   

        const newProductCreation4 = {
          sdate,
          edate,
          cbdays,
          cbhours,
          percentage,
          bdays,
          minamt,
          cremarks,
          productId
        }
        dispatch(
          newProductCancelPolicyCreation(newProductCreation4)
        )
        setSnackOpen3(true)

        setSdate('');
        setEdate('');
        setCbdays('');
        setCbhours('');
        setPercentage('');
        setBdays('');
        setMinamt('');
        setCRemarks('');
        setCancelButton(false)
        setCancelpView(false)

  }
    
  const handleOnSubmitAge = (e) => {
    e.preventDefault();
   
        const newProductCreation3 = {
            adultage,
            schildage,
            echildage,
            sinfantage,
            einfantage,
            productId
          }

        


        dispatch(
          newProductAgePolicyCreation(newProductCreation3)
        )
        setSnackOpen2(true)

        setAdultAge('');
        setSChildAge('');
        setEChildAge('');
        setSInfantAge('');
        setEInfantAge('');
        setAgeButton(false)
        setAgeView(false)


     
  }

  const nextTab = () => {

    setTabHandle('images');
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional: Smooth scrolling animation
    });
  }
  const nextTab2 = () => {
    setSnackOpen(true)
    setTabHandle('age-policy');
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional: Smooth scrolling animation
    });
  }

  const nextTab3 = () => {
    setTabHandle('occupancy-rule');
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional: Smooth scrolling animation
    });
  }

  const nextTab4 = () => {
    setTabHandle('occupancy-rule');
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional: Smooth scrolling animation
    });
  }


  const handleOnSubmit4 = (e) => {
    e.preventDefault();
   
        const newProductCreation4 = {
            minadult,
            maxadult,
            minchild,
            maxchild,
            mininfant,
            maxinfant,
            productId
          }

        


        dispatch(
          newProductOccupancyRuleCreation(newProductCreation4)
        )

       

        Swal.fire({
          title: 'Success!',
          text: 'Product Details Added Successfully',
          icon: 'success',
          confirmButtonText: 'Okay'
        })

        navigate('/productList');
        reset()
       
     
  }



    // const selectFiles = (event) => {
    //   let images = [];
  
    //   for (let i = 0; i < event.target.files.length; i++) {
    //     images.push(URL.createObjectURL(event.target.files[i]));
    //   }
    //   setSelectedFiles([]);
    //   setSelectedFiles(event.target.files);
    //   setImagePreviews(images);
    //   setProgressInfos([]);
    //   setMessage([]);
    // };


    const selectFiles = (event) => {
      setDup(false);
      let images = [];
      let selectedFiles = [];
    
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        if (file.type === 'image/webp') {
          images.push(URL.createObjectURL(file));
          selectedFiles.push(file);
        }
      }
    
      setSelectedFiles(selectedFiles);
      setImagePreviews(images);
      setProgressInfos([]);
      setMessage([]);
    };
    

    // const uploadImages =  (e) => {
    //   e.preventDefault();
    //   if (selectedFiles.length==0) {
    //     // show an error message
    //     let failure_result= {
    //       message: "Please Select a image file(Webp)",
         
    //     }
    //     dispatch(imageUploadFailureProcess(failure_result));
    //     setMessage([]);
    //     setProgressInfos([]);
    //     return;
    //   }
  
       
    //   setMessage([]);
 
     
    //   for (let i = 0; i < selectedFiles.length; i++) {
      
    //     upload(i,productId, selectedFiles[i]);
    //   }
    //   fileref.current.value='';

    //   setSnackOpen4(true);

    // };
    const uploadImages = (e) => {
      setDup(true);
      e.preventDefault();
      if (selectedFiles.length === 0) {
        // show an error message
        let failure_result = {
          message: "Please Select an image file (Webp)",
        };
        Swal.fire("Image Upload Failed!!","Please Select an image file (Webp).",'error')
        dispatch(imageUploadFailureProcess(failure_result));
        setMessage([]);
        setProgressInfos([]);
        return;
      }
    
      setMessage([]);
    
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        
        if (file.size > 1024 * 1024) {
          // Show an error message for files larger than 1MB
          let failure_result = {
            message: "Selected image is too large. Please select an image under 1MB.",
          };
          Swal.fire("Image Upload Failed!!","Selected image is too large. Please select an image under 1MB.",'error')


          dispatch(imageUploadFailureProcess(failure_result));
          setMessage([]);
          setProgressInfos([]);
          return;
        }
        
        upload(i, productId, file);
      }
      
      // Reset the file input value
      fileref.current.value = '';
    
      setSnackOpen4(true);
    };
    

    const upload = (idx,product_id, file) => {

      
      let _progressInfos = [...progressInfos];

   
      return UploadService.upload(file,product_id, (event) => {
        _progressInfos[idx].percentage = Math.round(
          (100 * event.loaded) / event.total
        );
        setProgressInfos(_progressInfos);
      })
        .then(() => {
          setMessage((prevMessage) => [
            ...prevMessage,
            "Image Uploaded Successfully: " + file.name,
          ]);
       
          let success_result= {
            message: "Image Uploaded Successfully",
           
          }
          dispatch(imageuploadProcess(success_result));
        })
        .catch(() => {
          _progressInfos[idx].percentage = 0;
          setProgressInfos({ val: _progressInfos });
  
          setMessage((prevMessage) => [
            ...prevMessage,
            "Could not upload the image: " + file.name,
          ]);
        });

        
    };


    useEffect(() => {
      

     
     let objectLength = Object.keys(selectedFiles).length;
     let _progressInfos = [];
     

if(objectLength>0)
{
      for (let i = 0; i < selectedFiles.length; i++) {
       _progressInfos.push({ percentage: 0, fileName: selectedFiles[i].name });
      }
    }   
  
     setProgressInfos([]);
       setProgressInfos([...progressInfos, ..._progressInfos]);

                
    }, [selectedFiles]);

  const canSave = Boolean (productname) && Boolean(servicetypeid) && Boolean(tourtypeid) && Boolean(phonenumber) && Boolean(cityid) && Boolean(countryid) && Boolean(status) 
  const canSave2 = Boolean (amaheight) && Boolean(amiheight) && Boolean(amaweight) && Boolean(amiweight) && Boolean(cmaheight) && Boolean(cmiheight) && Boolean(cmaweight) && Boolean(cmiweight) && Boolean(aip) || Boolean(acp) || Boolean(aap) 
  const canSaveAge = schildage !== '' || echildage !== '' || sinfantage !== '' || einfantage !== '' || adultage !== ''
  const canSaveCancel = Boolean (sdate) && Boolean(edate) 
  const canFileupload = Boolean (productname) && Boolean(servicetypeid) && Boolean(cityid) && Boolean(countryid) && Boolean(status) && Boolean(pcstatus)

const top100Films = [
  { title: 'The Shawshank Redemption', year: 1994 },
  { title: 'The Godfather', year: 1972 },
  { title: 'The Godfather: Part II', year: 1974 },
  { title: 'The Dark Knight', year: 2008 },
  { title: '12 Angry Men', year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: 'Pulp Fiction', year: 1994 },
];


  return (
    <>
    
    <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Create New Product</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/productList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
                {/* {pcMessage && (<Alert variant={pcstatus === "success" ? "success" : "danger"}>{ pcMessage}</Alert>)} */}
                {/* {paxMessage && (<Alert variant={paxstatus === "success" ? "success" : "danger"}>{ paxMessage}</Alert>)} */}
                <div>
                  <Snackbar
                    open={snackopen}
                    autoHideDuration={6000}
                    onClose={handleClose}
                    message="Pax and Health Details Added Successfully"
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Position the Snackbar top right

                    action={action}
                  >


                  <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleClose}
                    severity="success" // Set the severity to "success" for the green color
                    sx={{ width: '100%' }}
                  >
                    Pax and Health Details Added Successfully
                    
                  </MuiAlert>
                  </Snackbar>
                </div>

                <div>
               
                 <Snackbar
                  open={snackopen2}
                  autoHideDuration={6000}
                  onClose={handleClose2}
                  message="Age Policy Details Added Successfully"
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Position the Snackbar top right

                  action={action2}
                >

                  <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleClose2}
                    severity="success" // Set the severity to "success" for the green color
                    sx={{ width: '100%' }}
                  >
                    Age Policy Details Added Successfully
                  </MuiAlert>
                  </Snackbar>
                </div>
                <div>
                 <Snackbar
                  open={snackopen3}
                  autoHideDuration={6000}
                  onClose={handleClose3}
                  message="Cancellation Policy Details Added Successfully"
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Position the Snackbar top right

                  action={action3}
                >

                  <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleClose3}
                    severity="success" // Set the severity to "success" for the green color
                    sx={{ width: '100%' }}
                  >
                    Cancellation Policy Details Added Successfully
                  </MuiAlert>
                  </Snackbar>
                </div>
                <div>
                 <Snackbar
                  open={snackopen4}
                  autoHideDuration={6000}
                  onClose={handleClose4}
                  variant="success"
                  message="Uploaded Successfully"
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Position the Snackbar top right

                  action={action4}
                >
                  <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleClose4}
                    severity="success" // Set the severity to "success" for the green color
                    sx={{ width: '100%' }}
                  >
                    Uploaded Successfully
                    
                  </MuiAlert>
                  </Snackbar>
                </div>



                <div>
                 <Snackbar
                  open={snackopen5}
                  autoHideDuration={6000}
                  onClose={handleClose5}
                  variant="success"
                  message="Basic Details Added Successfully"
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Position the Snackbar top right

                  action={action5}
                >
                  <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleClose5}
                    severity="success" // Set the severity to "success" for the green color
                    sx={{ width: '100%' }}
                  >
                    Basic Details Added Successfully
                    
                  </MuiAlert>
                  </Snackbar>
                </div>
           
            <br />
            <Tabs
      // defaultActiveKey='basic'
      activeKey={tabHandle}
      id="justify-tab-example"
      className="mb-3"
      justify
    >
      <Tab eventKey="basic" title="Basic Details ">
      <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit(e))}> {/* handleOnSubmit() */}

<Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Name <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="text" ref={ProductRef}  name="productname" required="true" autoComplete='off' placeholder="Enter Product Name" {...register("productname", { required: true, mixLength: 3 })}  onChange={(e) => setProductname(e.target.value)}/>
    {errors.productname && <p className='text-danger'> Product Name required</p>}
  </Form.Group>
 
  {/* <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Phone No <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="text" ref={ProductRef}  name="phonenumber" required="true" autoComplete='off' placeholder="Enter Mobile No" {...register("mobile", { required: true, mixLength: 3 })}  onChange={(e) => setPhonenumber(e.target.value)}/>
    <PhoneInput className='form-control' pattern="[0-9]{10}" title="Enter a valid phone number" maxLength={15} placeholder="Enter phone number" required="true" style={{height:"38px",border:""}} value={phonenumber} ref={ProductRef} {...register("mobile", { required: true, mixLength: 3 })}  onChange={setPhonenumber} name="phonenumber" />
    {errors.phonenumber && <p className='text-danger'> Phone No required</p>}
   
  </Form.Group> */}
  <Form.Group as={Col} controlId="formGridMobile">
  <Form.Label>Phone No <span className='text-danger'>*</span></Form.Label>
  <PhoneInput
    className='form-control'
    placeholder="Enter phone number"
    required={true}
    defaultCountry="IN" // Set the default country to India
    value={phonenumber}
    ref={ProductRef} 
    {...register("mobile", { required: true })}
    name="phonenumber"
    onChange={setPhonenumber}
    onBlur={() => {
      try {
        const phoneNumber = parsePhoneNumber(phonenumber);
        if (!phoneNumber || !phoneNumber.isValid()) {
          setPhonenumber();
          Swal.fire({
            title: 'error!',
            text: 'Please Enter Valid Number',
            icon: 'error',
            confirmButtonText: 'Okay'
          })

        }
        // if (phoneNumber.country === 'IN' && phoneNumber.nationalNumber.length !== 10) {
        //   throw new Error('Phone number must be 10 digits for India');
        // }
      } catch (error) {
        // console.error(error);
        // Handle the validation error, e.g., set an error state
      }
    }}
  />
  {errors.phonenumber && <p className='text-danger'>Phone No required</p>}
</Form.Group>
  </Row>

  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridServiceType">
    <Form.Label>Service <span className='text-danger'>*</span></Form.Label>
    <Form.Select  name="servicetypeid" required="true" onChange={(e) => setServicetypeid(e.target.value)}>
    <option  value="" >Choose</option>
      {serviceType.map((service,index) =>
    
      <option key={service.id} value={service.id} >{service.service_type}</option>
      )}
    </Form.Select>
    </Form.Group>

    <Form.Group as={Col} controlId="formGridServiceType">
    <Form.Label>Tour Type <span className='text-danger'>*</span></Form.Label>
    <Form.Select  name="tourtypeid" required="true" onChange={(e) => setTourtypeid(e.target.value)}>
    <option  value="" >Choose</option>
      {tourType.map((tour,index) =>
    
      <option key={tour.id} value={tour.id} >{tour.tour_type}</option>
      )}
    </Form.Select>
    </Form.Group>
    </Row>
  <Row className="mb-3">

    <Form.Group as={Col} controlId="formGridServiceType">
    <Form.Label>Country <span className='text-danger'>*</span></Form.Label>
    <Form.Select  name="countryid" required="true" onChange={(e) => setCountryid(e.target.value)}>
    <option  value="" >Choose</option>
      {country.map((countries,index) =>
    
      <option key={countries.id} value={countries.id} >{countries.country_name}</option>
      )}
    </Form.Select>
    </Form.Group>

    <Form.Group as={Col} controlId="formGridServiceType">
    <Form.Label>City <span className='text-danger'>*</span></Form.Label>
    <Form.Select  name="cityid" required="true" onChange={(e) => setCityid(e.target.value)}>
    <option  value="" >Choose</option>
      {city.map((cities,index) =>
    
      <option key={cities.id} value={cities.id} >{cities.city_name}</option>
      )}
    </Form.Select>
    </Form.Group>
  </Row>
  {/* <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridDialyStartTime">
  <Form.Label>Daily Start Time  </Form.Label>
  <Datetime initialViewMode="time" name="dailystarttime" updateOnView="time" dateFormat={false} timeFormat="HH:mm A" selected={dailystarttime} onChange={dailystarttime => setDailystarttime(dailystarttime)} />
    </Form.Group>

    <Form.Group as={Col} controlId="formGridDialyEndTime">
    <Form.Label>Daily End Time </Form.Label>
    <Datetime initialViewMode="time" name="dailyendime" updateOnView="time" dateFormat={false} timeFormat="HH:mm A"  selected={dailyendtime} onChange={dailyendtime => setDailyendtime(dailyendtime)} />
   
    </Form.Group>
  </Row> */}

  {/* <Row className="mb-3">
  
  <Form.Group as={Col} controlId="formGridRemarks">
    <Form.Label> Confirmation Remarks </Form.Label>
    
    <Form.Control type="text" ref={ProductRef}  name="remarks" autoComplete='off' placeholder="Enter Confirmation Remarks " {...register("remarks", { required: true, mixLength: 3 })}  onChange={(e) => setRemarks(e.target.value)}/>
    {errors.remarks && <p className='text-danger'>Confirmation Remarks  required</p>}
  </Form.Group>
  </Row> */}
 <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridAddress1">
    <Form.Label>Suppliers</Form.Label>
    
     <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      options={suppliers}
      limitTags={1}
      disableCloseOnSelect
      style={{height:"38px"}}
      getOptionLabel={(option) => option.supplier_name}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 ,height:"38px"}}
            checked={selected}
        
          />
          {option.supplier_name}
        </li>
      )}
      onChange={(e, options)=>{handleChangeSupplier(e, options)}}
   
      
      // style={{height:"38px" }}
      renderInput={(params) => (
        <TextField {...params} style={{height:"38px"}} label="" placeholder="Tag Suppliers" />
      )}
    />
  </Form.Group>
  <Form.Group as={Col} controlId="formGridReservationEmail">
    <Form.Label>Reservation Email(s)<span className='text-danger'>*</span></Form.Label>

    <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      options={reservationEmail}
      limitTags={1}
      disableCloseOnSelect
      style={{height:"38px"}}
      getOptionLabel={(option) => option.reservation_email}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 ,height:"38px"}}
            checked={selected}
        
          />
          {option.reservation_email}
        </li>
      )}
      onChange={(e, options)=>{handleChangeREmail(e, options)}}
   
      
      // style={{height:"38px" }}
      renderInput={(params) => (
        <TextField {...params} style={{height:"38px"}} label="" placeholder="Add Reservation Email" />
      )}
    />
  </Form.Group>
 
  </Row>
  <br />

  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridIsdummy">
  
  <Form.Check type="checkbox" ref={ProductRef}  name="isdummy"  label="Is Dummy Product?"  {...register("isdummy", { required: true, mixLength: 3 })}  onChange={(e) => handleCheckbox(e)} />
 
</Form.Group> 
<Form.Group as={Col} controlId="formGridHastax">
  
  <Form.Check type="checkbox" ref={ProductRef}  name="hastax"  label="Has TAX?"  {...register("hastax", { required: true, mixLength: 3 })}  onChange={(e) => handleCheckbox(e)} />
 
</Form.Group> 
{/* <Form.Group as={Col} controlId="formGridIstricombo2">
  
  <Form.Check type="checkbox" ref={ProductRef}  name="istricombo"  label="Tri Combo Product?"  {...register("istricombo", { required: true, mixLength: 3 })}  onChange={(e) => handleCheckbox(e)} />
 
</Form.Group>  */}
  </Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridIsbulkticket">
  
  <Form.Check type="checkbox" ref={ProductRef}  name="isbulkticket"  label="Bulk Ticket Purchase Permitted? "  {...register("isbulkticket", { required: true, mixLength: 3 })}  onChange={(e) => handleCheckbox(e)} />
 
</Form.Group> 
<Form.Group as={Col} controlId="formGridHasvat">
  
  <Form.Check type="checkbox" ref={ProductRef}  name="hasvat"  label="Has VAT?"  {...register("hasvat", { required: true, mixLength: 3 })}  onChange={(e) => handleCheckbox(e)} />
 
</Form.Group> 
  </Row>
  {/* <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridVouchertosbt">
  
  <Form.Check type="checkbox" ref={ProductRef}  name="vouchertosbt"  label="Is Send Voucher To SBT? "  {...register("vouchertosbt", { required: true, mixLength: 3 })}  onChange={(e) => handleCheckbox(e)} />
 
</Form.Group> 

  </Row> */}
  <Row className="mb-3">
 
 {/* <Form.Group as={Col} controlId="formGridNooftrips">
   <Form.Label>Daily Number of Trips </Form.Label>
   <Form.Control type="text" ref={ProductRef}  name="nooftrips" autoComplete='off' placeholder="Enter Daily Number of Trips" {...register("nooftrips", { required: true, mixLength: 3 })}  onChange={(e) => setNooftrips(e.target.value)}/>
   {errors.nooftrips && <p className='text-danger'> Daily Number of Trips required</p>}
   </Form.Group> */}
   {/* <Form.Group as={Col} controlId="formGridDresscode">
   <Form.Label>Dress Code</Form.Label>

   <Form.Control type="text" ref={ProductRef}  name="dresscode" autoComplete='off' placeholder="Enter Dress Code" {...register("dresscode", { required: true, mixLength: 3 })}  onChange={(e) => setDresscode(e.target.value)}/>
   {errors.dresscode && <p className='text-danger'>Dress Code required</p>}
 </Form.Group> */}
 <Form.Group as={Col} controlId="formGridStatus">
   <Form.Label>Status <label className='text-danger'>*</label></Form.Label>
       <Form.Select required name="status" {...register("status" , { required: true })} onChange={(e) => setStatus(e.target.value)}>
         
         <option value="">Choose..</option>
         <option value="1">Enable</option>
         <option value="0">Disable</option>
       </Form.Select>
       {errors.status && <p className='text-danger'>Status required</p>}
     </Form.Group>

 </Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductdescription">
  <Form.Label>Description</Form.Label>
  
   <DefaultEditor rows="5"  ref={ProductRef} value={productdescription}  name="productdescription" {...register("productdescription", { required: true, mixLength: 3 })}  onChange={(e) => setProductdescription(e.target.value)}
    />

</Form.Group>


</Row>
<div class="d-grid  col-2 mx-auto" style={{display:"flex"}}>
<Button variant="primary" type="submit" className="btn btn-success btn-block" style={{backgroundColor:'#1c355e'}} disabled={!canSave}>
<FontAwesomeIcon icon={faRightToBracket} /> Save
</Button>
&nbsp;&nbsp;<Button  className="btn btn-success btn-block" onClick={nextTab}  disabled={pcstatus === "success" ? false : true}>Next</Button>
</div>
{/* {piscLoading && (<Spinner variant='info' animation='border' />)} */}

</Form>
      </Tab>
      <Tab eventKey="images" title="Images & Videos">

        <p style={{color:'#bb0e0e',marginLeft:'25px'}}>Note: Image Format Should be in Webp</p>
        
      <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(uploadImages(e))}>
<div className="form-group multi-preview">
{/* {(this.fileArray || []).map(url => (
                        <img src={url} alt="..." />
                    ))} */}
</div>

<div className="form-group">
<input type="file" className="form-control" onChange={(e) => selectFiles(e)}  multiple disabled={!canFileupload}  accept="image/webp" ref= {fileref} />
<input type="hidden" name="productid" id="productid" value={productId}/>
</div>
<br />
<Button type="submit" className="btn btn-danger btn-block"  disabled={dup} >Upload</Button>&nbsp;&nbsp;<Button  className="btn btn-success btn-block" onClick={()=>setTabHandle('longer-tab')}  >Next</Button>
</Form>
 {progressInfos &&
          progressInfos?.map((progressInfo, index) => (
            <div className="mb-2" key={index}>
              <span>{progressInfo?.fileName}</span>
              <div className="progress">
                <div
                  className="progress-bar progress-bar-info"
                  role="progressbar"
                  aria-valuenow={progressInfo?.percentage}
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: progressInfo?.percentage + "%" }}
                >
                  {progressInfo?.percentage}%
                </div>
              </div>
            </div>
          ))}  

{message?.length > 0 && (
          <div className="alert alert-secondary" role="alert">
            <ul>
              {message.map((item, i) => {
                return <li key={i}>{item}</li>;
              })}
            </ul>
          </div>
        )}
              </Tab> 
      <Tab eventKey="longer-tab" title="Pax and Health">
      <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit2(e))}> {/* handleOnSubmit() */}
      <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridIsdummy">
  
  <Form.Check type="checkbox" ref={ProductRef}  name="acp"  label="Are Children Permitted ?"  {...register("acp", { required: true, mixLength: 3 })}  onChange={(e) => handleCheckboxAcp(e)} />
 
</Form.Group> 
<Form.Group as={Col} controlId="formGridIstricombo2">
  
  <Form.Check type="checkbox" ref={ProductRef}  name="aip"  label="Are Infants Permitted ?"  {...register("aip", { required: true, mixLength: 3 })}  onChange={(e) => handleCheckboxAip(e)} />
 
</Form.Group> 
<Form.Group as={Col} controlId="formGridIsdummy">
  
  <Form.Check type="checkbox" ref={ProductRef}  name="aap"  label="Are Adults Permitted ?"  {...register("aap", { required: true, mixLength: 3 })}  onChange={(e) => handleCheckboxAap(e)} />
 
</Form.Group> 

  </Row>
  <hr />
      <input type="hidden" name="productid" id="productid" value={productId}/>
<Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Adult Minimum Height (cm) <span className='text-danger'></span></Form.Label>
    <Form.Control type="number" min="1" max="300" ref={ProductRef} disabled={aap == 1 || aap == true ? 0 : 1}  name="amiheight" required="true" autoComplete='off' placeholder="Adult Minimum Height (cm)" {...register("amiheight", { required: true, mixLength: 3 })}  onChange={(e) => setAmiHeight(e.target.value)}
     onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(1, Math.min(300, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
    {errors.amih && <p className='text-danger'> Adult Minimum Height  required</p>}
  </Form.Group>
 
  <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Adult Maximum Height (cm) <span className='text-danger'></span></Form.Label>
    <Form.Control type="number" min={amiheight} max="300" ref={ProductRef}  disabled={aap == 1 || aap == true ? 0 : 1}  name="amaheight" required="true" autoComplete='off' placeholder="Adult Maximum Height (cm)" {...register("amaheight", { required: true, mixLength: 3 })}  onChange={(e) => setAmaHeight(e.target.value)}
    
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(amiheight, Math.min(300, inputValue));
        event.target.value = inputValue;
      }
    }}
    />
    {errors.amah && <p className='text-danger'> Adult Minimum Height  required</p>}
  </Form.Group>
  </Row>

  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Adult Minimum Weight (kg) <span className='text-danger'></span></Form.Label>
    <Form.Control type="number" min="1" max="300" ref={ProductRef} disabled={aap == 1 || aap == true ? 0 : 1}   name="amiweight" required="true" autoComplete='off' placeholder="Adult Minimum Weight (kg)" {...register("amiweight", { required: true, mixLength: 3 })}  onChange={(e) => setAmiWeight(e.target.value)}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(1, Math.min(300, inputValue));
        event.target.value = inputValue;
      }
    }}
    />
    {errors.amiw && <p className='text-danger'> Adult Minimum Weight  required</p>}
  </Form.Group>
 
  <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Adult Maximum Weight (kg) <span className='text-danger'></span></Form.Label>
    <Form.Control type="number" min={amiweight} max="300" ref={ProductRef} disabled={aap == 1 || aap == true ? 0 : 1}   name="amaweight" required="true" autoComplete='off' placeholder="Adult Maximum Weight (kg)" {...register("amaweight", { required: true, mixLength: 3 })}  onChange={(e) => setAmaWeight(e.target.value)}
     onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(amiweight, Math.min(300, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
    {errors.amaw && <p className='text-danger'> Adult Maximum Weight  required</p>}
  </Form.Group>
  </Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Child Minimum Height (cm) <span className='text-danger'></span></Form.Label>
    <Form.Control type="number" min="1" max="300" ref={ProductRef} disabled={acp == 1 || acp == true ? 0 : 1}   name="cmiheight" required="true" autoComplete='off' placeholder="Child Minimum Height (cm)" {...register("cmiheight", { required: true, mixLength: 3 })}  onChange={(e) => setCmiHeight(e.target.value)}
      onInput={(event) => {
        let inputValue = parseInt(event.target.value);
        if (isNaN(inputValue)) {
          event.target.value = '';
        } else {
          inputValue = Math.max(1, Math.min(300, inputValue));
          event.target.value = inputValue;
        }
      }}
    
    />
    {errors.cmih && <p className='text-danger'>Child Minimum Height (cm)  required</p>}
  </Form.Group>
 
  <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Child Maximum Height (cm) <span className='text-danger'></span></Form.Label>
    <Form.Control type="number" min={cmiheight} max="300" ref={ProductRef} disabled={acp == 1 || acp == true ? 0 : 1}  name="cmaheight" required="true" autoComplete='off' placeholder="Child Maximum Height (cm)" {...register("cmaheight", { required: true, mixLength: 3 })}  onChange={(e) => setCmaHeight(e.target.value)}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(cmiheight, Math.min(300, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
    {errors.cmah && <p className='text-danger'>Child Maximum Height (cm)  required</p>}
  </Form.Group>
  </Row>

  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Child Minimum Weight (kg) <span className='text-danger'></span></Form.Label>
    <Form.Control type="number" min="1" max="300" ref={ProductRef}  disabled={acp == 1 || acp == true ? 0 : 1}   name="cmiweight" required="true" autoComplete='off' placeholder="Child Minimum Weight (kg)" {...register("cmiweight", { required: true, mixLength: 3 })}  onChange={(e) => setCmiWeight(e.target.value)}
     onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(1, Math.min(300, inputValue));
        event.target.value = inputValue;
      }
    }}
    />
    {errors.cmiw && <p className='text-danger'>Child Minimum Weight (kg)  required</p>}
  </Form.Group>
 
  <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Child Maximum Weight (kg) <span className='text-danger'></span></Form.Label>
    <Form.Control type="number" min={cmiweight} max="300" ref={ProductRef}  disabled={acp == 1 || acp == true ? 0 : 1}   name="cmaweight" required="true" autoComplete='off' placeholder="Child Maximum Weight (kg)" {...register("cmaweight", { required: true, mixLength: 3 })}  onChange={(e) => setCmaWeight(e.target.value)}
     onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(cmiweight, Math.min(300, inputValue));
        event.target.value = inputValue;
      }
    }}
    />
    {errors.cmaw && <p className='text-danger'>Child Maximum Weight (kg)  required</p>}
  </Form.Group>
  </Row>


 
  




  <Form.Group as={Col} controlId="formGridStatus">
    <Form.Label>Status <label className='text-danger'></label></Form.Label>
        <Form.Select required name="status2" {...register("status2" , { required: true })} onChange={(e) => setStatus2(e.target.value)}>
          
          <option value="">Choose..</option>
          <option value="1">Enable</option>
          <option value="0">Disable</option>
        </Form.Select>
        {errors.status && <p className='text-danger'>Status required</p>}
      </Form.Group>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductdescription">
  <Form.Label>Health Restrictions</Form.Label>
  
   <DefaultEditor rows="5"  ref={ProductRef} value={healthrestrictions}  name="healthrestrictions" {...register("healthrestrictions", { required: true, mixLength: 3 })}  onChange={(e) => setHealthrestrictions(e.target.value)}
    />

</Form.Group>


</Row>
<div class="d-grid  col-2 mx-auto">
<Button variant="primary" type="submit" className="btn btn-success btn-block" style={{backgroundColor:'#1c355e'}}  onClick={nextTab2} disabled={!canSave2}>
<FontAwesomeIcon icon={faRightToBracket} /> Save
</Button>

{/* &nbsp;&nbsp;<Button  className="btn btn-success btn-block" onClick={()=>setTabHandle('age-policy')}  disabled={pcstatus === "success" ? false : true}>Next</Button> */}
</div>
{/* {piscLoading && (<Spinner variant='info' animation='border' />)} */}

</Form>
      </Tab>
      


      <Tab eventKey="age-policy" title="Policies">
    


      <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmitAge(e))}> {/* handleOnSubmit() */}
      <input type="hidden" name="productid" id="productid" value={productId}/>
      <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridIsdummy">
  
  <Form.Check type="checkbox" ref={ProductRef}  name="ageview"  label="Age Policy" disabled={!ageButton} onChange={handleageview} />
 
</Form.Group> 
</Row>
      {ageview && ( <><Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Adult Age (Above) <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="1" max="300" ref={ProductRef}  name="adultage" required="true" disabled={!prdata.adult_permission} autoComplete='off' placeholder="Age Above" {...register("adultage", { required: true, mixLength: 3 })}  onChange={(e) => setAdultAge(e.target.value)}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(1, Math.min(300, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
    {errors.adultage && <p className='text-danger'> Adult Age required</p>}
  </Form.Group>
 
 
  </Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Child Age (Start) <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="1" max="17" ref={ProductRef}  name="schildage" disabled={!prdata.child_permission} required="true" autoComplete='off' placeholder="Enter child start age" {...register("schildage", { required: true, mixLength: 3 })}  onChange={(e) => setSChildAge(e.target.value)}
     onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(1, Math.min(17, inputValue));
        event.target.value = inputValue;
      }
    }}
    />
    {errors.schildage && <p className='text-danger'> Start Child Age required</p>}
  </Form.Group>

  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Child Age (End) <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min={schildage} max="17" ref={ProductRef}  name="echildage" disabled={!prdata.child_permission} required="true" autoComplete='off' placeholder="Enter child end age" {...register("echildage", { required: true, mixLength: 3 })}  onChange={(e) => setEChildAge(e.target.value)}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(schildage, Math.min(17, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
    {errors.schildage && <p className='text-danger'> Start Child Age required</p>}
  </Form.Group>
 
 
  </Row>


  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Infant Age (Start) <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="0" max="6" ref={ProductRef} disabled={!prdata.infant_permission}  name="sinfantage" required="true" autoComplete='off' placeholder="Enter infant start age" {...register("sinfantage", { required: true, mixLength: 3 })}  onChange={(e) => setSInfantAge(e.target.value)}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(0, Math.min(6, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
    {errors.schildage && <p className='text-danger'> Start Infant Age required</p>}
  </Form.Group>

  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Infant Age (End) <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min={sinfantage} max="6" ref={ProductRef} disabled={!prdata.infant_permission}  name="einfantage" required="true" autoComplete='off' placeholder="Enter infant end age" {...register("einfantage", { required: true, mixLength: 3 })}  onChange={(e) => setEInfantAge(e.target.value)}
     onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(sinfantage, Math.min(6, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
    {errors.schildage && <p className='text-danger'> Start Infant Age required</p>}
  </Form.Group>
 
 
  </Row>
  <div class="d-grid  col-2 mx-auto">
    {console.log("canSave",canSaveAge)}
<Button variant="primary" style={{backgroundColor:'#1c355e'}} type="submit" className="btn btn-success btn-block"  disabled={!canSaveAge}>
<FontAwesomeIcon icon={faRightToBracket} /> Save
</Button>
&nbsp;&nbsp;<Button  className="btn btn-success btn-block"  onClick={nextTab3} disabled={ageButton}>Next</Button>
</div>

</>)}  



</Form>
<hr />
<Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit3(e))}> {/* handleOnSubmit() */}

<Row className="mb-3">

<Form.Group as={Col} controlId="formGridIstricombo2">
  
  <Form.Check type="checkbox" ref={ProductRef}  name="cancelview" disabled={!cancelButton}   label="Cancellation Policy"  onChange={handlecancelview} />
 
</Form.Group> 
</Row>

{cancelpview && ( <>
  <Row className="mb-3">

<Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Start Date<span className='text-danger'>*</span></Form.Label>
    <Form.Control type="date" ref={ProductRef}  name="sdate" min={new Date().toISOString().split('T')[0]}  required="true" autoComplete='off' placeholder="Enter the start date" {...register("sdate", { required: true, mixLength: 3 })}  onChange={(e) => setSdate(e.target.value)}/>
  </Form.Group>
  <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>End Date<span className='text-danger'>*</span></Form.Label>
    <Form.Control type="date" ref={ProductRef}  name="edate" min={sdate}  required="true" autoComplete='off' placeholder="Enter the end date" {...register("edate", { required: true, mixLength: 3 })}  onChange={(e) => setEdate(e.target.value)}/>
  </Form.Group>
  
  </Row>


<Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Refund Rule <span className='text-danger'>*</span></Form.Label>
    <Form.Select required name="before" {...register("before" , { required: true })} onChange={(e) => handleBefore(e.target.value)}>
          
          <option value="">Choose..</option>
          <option value="Day">Day</option>
          <option value="Hour">Hour</option>
        </Form.Select>  </Form.Group>
 {dayShow == true && <> <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Cancel Before Days<span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="0" ref={ProductRef}  name="cbdays" required="true" autoComplete='off' placeholder="Enter The Number of Days" {...register("cbdays", { required: true, mixLength: 3 })}  onChange={(e) => setCbdays(e.target.value)}/>
  </Form.Group></>}
 
{timeShow == true && <><Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Cancel Before Hours <span className='text-danger'>*</span></Form.Label>
    <Datetime initialViewMode="time" name="cbhours" {...register("cbhours", { required: true, mixLength: 3 })} updateOnView="time" dateFormat={false} timeFormat="HH:mm" onChange={(e) => setCbhours(e)} />
  </Form.Group></>}
  </Row>


  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Refund Policy <span className='text-danger'>*</span></Form.Label>
    <Form.Select required name="per" {...register("per" , { required: true })} onChange={(e) => handlePercentage(e.target.value)}>
          
          <option value="">Choose..</option>
          <option value="Percentage">Percentage</option>
          <option value="Minamt">Minimum Amount</option>
        </Form.Select>  </Form.Group>
 {perShow == true && <> <Form.Group as={Col} controlId="formGridMobile">
 <Form.Label>Percentage<span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="0" ref={ProductRef}  name="percentage" required="true" autoComplete='off' placeholder="Enter the percentage" {...register("percentage", { required: true, mixLength: 3 })}  onChange={(e) => setPercentage(e.target.value)}/>
  </Form.Group></>}
 
{minamtShow == true && <> <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Min Amount<span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="0" ref={ProductRef}  name="minamt" required="true" autoComplete='off' placeholder="Enter Minimum Amount" {...register("minamt", { required: true, mixLength: 3 })}  onChange={(e) => setMinamt(e.target.value)}/>
  </Form.Group></>}
  </Row>


    <Row className="mb-3">
    <Form.Group as={Col} controlId="formGridMobile">
<Form.Label>Buffer Days<span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="0" ref={ProductRef}  name="bdays" required="true" autoComplete='off' placeholder="Enter Buffer Days" {...register("bdays", { required: true, mixLength: 3 })}  onChange={(e) => setBdays(e.target.value)}/>
  </Form.Group>
 
  <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Remarks<span className='text-danger'>*</span></Form.Label>
    <Form.Control as="textarea" rows={3} type="number" ref={ProductRef}  name="cremarks" required="true" autoComplete='off' placeholder="Enter the remarks" {...register("cremarks", { required: true, mixLength: 3 })}  onChange={(e) => setCRemarks(e.target.value)}/>
  </Form.Group>

  </Row>
  <div class="d-grid  col-2 mx-auto">
<Button variant="primary" style={{backgroundColor:'#1c355e'}} type="submit" className="btn btn-success btn-block" disabled={!canSaveCancel}>
<FontAwesomeIcon icon={faRightToBracket} /> Save
</Button>
&nbsp;&nbsp;<Button  className="btn btn-success btn-block"  onClick={nextTab4} disabled={cancelButton}>Next</Button>

{/* &nbsp;&nbsp;<Button  className="btn btn-success btn-block" onClick={()=>setTabHandle('occupancy-rule')}  disabled={pcstatus === "success" ? false : true}>Next</Button> */}
</div>
</>)}
<hr />

{/* {piscLoading && (<Spinner variant='info' animation='border' />)} */}

</Form>
<div class="d-grid  col-2 mx-auto">
&nbsp;&nbsp;<Button  className="btn btn-success btn-block"  onClick={nextTab3} disabled={cancelpview == false && ageview == false ? 0 : 1}>Next</Button>
</div>
      </Tab>



      
      <Tab eventKey="occupancy-rule" title="Occupancy Rule">
    


      <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit4(e))}> {/* handleOnSubmit() */}
      <input type="hidden" name="productid" id="productid" value={productId}/>
      <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridIsdummy">
  
  {/* <Form.Check type="checkbox" ref={ProductRef}  name="ageview"  label="Age Policy"  onChange={handleageview} /> */}
 
</Form.Group> 
</Row>
    <><Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Minimum Adult <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="1" max="500" ref={ProductRef}  name="minadult" required="true" disabled={!prdata.adult_permission} autoComplete='off' placeholder="Enter Minimum Adult" {...register("minadult", { required: true, mixLength: 3 })}  onChange={(e) => setMinAdult(e.target.value)}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(1, Math.min(500, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    
    />
  </Form.Group>
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Maximum Adult <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min={minadult} max="500" ref={ProductRef}  name="maxadult" required="true" disabled={!prdata.adult_permission} autoComplete='off' placeholder="Enter Maximum Adult" {...register("maxadult", { required: true, mixLength: 3 })}  onChange={(e) => setMaxAdult(e.target.value)}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(minadult, Math.min(500, inputValue));
        event.target.value = inputValue;
      }
    }}
    
    />
  </Form.Group>
 
 
  </Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Minimum Child <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="0" max="500" ref={ProductRef}  name="minchild" disabled={!prdata.child_permission} required="true" autoComplete='off' placeholder="Enter Minimum Child" {...register("minchild", { required: true, mixLength: 3 })}  onChange={(e) => setMinChild(e.target.value)}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(0, Math.min(500, inputValue));
        event.target.value = inputValue;
      }
    }}
    />
  </Form.Group>

  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Maximum Child <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min={minchild} max="500" ref={ProductRef}  name="maxchild" disabled={!prdata.child_permission} required="true" autoComplete='off' placeholder="Enter Maximum Child" {...register("maxchild", { required: true, mixLength: 3 })}  onChange={(e) => setMaxChild(e.target.value)}
    onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(minchild, Math.min(500, inputValue));
        event.target.value = inputValue;
      }
    }}
    />
  </Form.Group>
 
 
  </Row>


  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Minimum Infant <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min="0" max="500" ref={ProductRef}  name="mininfant" disabled={!prdata.infant_permission} required="true" autoComplete='off' placeholder="Enter Minimum Infant" {...register("mininfant", { required: true, mixLength: 3 })}  onChange={(e) => setMinInfant(e.target.value)}
     onInput={(event) => {
      let inputValue = parseInt(event.target.value);
      if (isNaN(inputValue)) {
        event.target.value = '';
      } else {
        inputValue = Math.max(0, Math.min(500, inputValue));
        event.target.value = inputValue;
      }
    }}
    />
  </Form.Group>

  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Maximum Infant <span className='text-danger'>*</span></Form.Label>
    <Form.Control type="number" min={mininfant} max="500" ref={ProductRef}  name="maxinfant" disabled={!prdata.infant_permission} required="true" autoComplete='off' placeholder="Enter Maximum Infant" {...register("maxinfant", { required: true, mixLength: 3 })}  onChange={(e) => setMaxInfant(e.target.value)}
      onInput={(event) => {
        let inputValue = parseInt(event.target.value);
        if (isNaN(inputValue)) {
          event.target.value = '';
        } else {
          inputValue = Math.max(mininfant, Math.min(500, inputValue));
          event.target.value = inputValue;
        }
      }}
      
    
    />
  </Form.Group>
 
  </Row>
</>



<div class="d-grid  col-2 mx-auto">
<Button variant="primary" type="submit" style={{backgroundColor:'#1c355e'}}  className="btn btn-success btn-block" disabled={!canSave}>
<FontAwesomeIcon icon={faRightToBracket} /> Save
</Button>
</div>
{/* {piscLoading && (<Spinner variant='info' animation='border' />)} */}

</Form>
      </Tab>
      
      
    </Tabs>
    </div>
                </div>
            </div>
    </>
  );
}

export default CreateProduct;